<template>
    <div class="tab-proposals">
        <EmptyTabsCard
            v-if="!proposals"
            :loading="loading"
            :emptyImgLink="emptyImgLink"
            cardTitle="Инициативы"
            toFullRouter="/proposal/create"
            emptyText="Вы еще не подавали заявку <br> на проектную инициативу"
            button-text="Подать заявку"
        />
        <Folder class="proposal-folder" title="Инициативы" v-else>
            <MineProposals :loading="loading" :items="proposals" />
            <Button :to="{ name: 'proposal', params: { id: 'create' } }" class="btn_create">Предложить проект</Button>
        </Folder>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Folder from '../../UI/Folder';
import Button from '../../UI/Button';
import MineProposals from './tab-proposal/MineProposals';
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';

export default {
    name: 'TabProposal',
    computed: {
        ...mapGetters('proposals', ['proposals']),
        emptyImgLink() {
            return require(`../../../assets/images/oops-rhino.svg`);
        },
    },
    data: () => ({
        loading: false,
    }),
    methods: {
        ...mapActions('proposals', ['loadProposals']),
    },
    async mounted() {
        if (this.proposals.length === 0) {
            this.loading = true;
        }
        await this.loadProposals();
        this.loading = false;
    },
    components: {
        EmptyTabsCard,
        MineProposals,
        Folder,
        Button,
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';
@import '../../../styles/variables';

.proposal-folder {
    margin-bottom: rem(24);
    border-radius: rem(10);

    @media (max-width: $vm) {
        margin-bottom: mrem(24);
    }

    &:last-of-type {
        @include on-mobile {
            margin-bottom: 0;
        }
    }

    .btn_create {
        width: rem(256);

        @include on-mobile {
            width: 100%;
        }
    }
}
</style>
